import { useTranslation } from "react-i18next";

/**
 * Cart size label distinguishing distinct products from total units:
 * "3 items · 500 units". Collapses to just "3 items" when every line has
 * quantity 1, where the unit count would be redundant.
 */
export function useCartCountLabel(
  distinctItems: number,
  totalUnits: number,
): string {
  const { t } = useTranslation();
  const items = t("components.orders.cartCounts.itemCount", {
    count: distinctItems,
  });
  if (totalUnits === distinctItems) return items;
  return `${items} · ${t("components.orders.cartCounts.unitCount", { count: totalUnits })}`;
}
